const GeneralSearch = {
    keywords: [] 
}

export default GeneralSearch;